import { render } from "./APdfThumbnail.vue?vue&type=template&id=4cfa72c0"
import script from "./APdfThumbnail.vue?vue&type=script&lang=js"
export * from "./APdfThumbnail.vue?vue&type=script&lang=js"

import exportComponent from "/home/ben/work/acon/acon-360/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__